export const uid = () =>
  (crypto.randomUUID ? crypto.randomUUID() :
    'txn-' + Date.now() + '-' + Math.random().toString(16).slice(2));

export const money = (n) =>
  '₹' + Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 });

export const money2 = (n) =>
  '₹' + Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtDate = (iso) => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit' });
  } catch { return iso; }
};

export const fmtDateShort = (iso) => {
  if (!iso) return '';
  try { return new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' }); }
  catch { return iso; }
};

export const PAYMENT_METHODS = ['CASH', 'UPI', 'CARD', 'BANK', 'CREDIT'];

export const STATUS_STYLES = {
  AVAILABLE: 'bg-emerald-50 text-emerald-800 ring-1 ring-emerald-200',
  SOLD: 'bg-slate-100 text-slate-700 ring-1 ring-slate-200',
  IN_TRANSIT: 'bg-amber-50 text-amber-800 ring-1 ring-amber-200',
  RETURNED: 'bg-blue-50 text-blue-800 ring-1 ring-blue-200',
};
